const setupFormie = (el) => {
  const scriptTag = el.parentNode.querySelector('script')
  const src = scriptTag.src
  const newScriptTag = document.createElement('script')

  newScriptTag.src = src
  scriptTag.parentNode.appendChild(newScriptTag)
  scriptTag.remove()

  newScriptTag.addEventListener('load', () => {
    window.Formie.initForms()
  })
}

export default setupFormie
